import React, { useEffect } from 'react'
import { Transition } from '@headlessui/react'
import {
  IconX,
  IconDots,
  IconCheck,
  IconCircleCheck,
} from '@tabler/icons-react'

import { cn } from 'utils/classMerge'
import Text from 'components/ui/text'

const typeToAssets = {
  progress: {
    icon: (
      <IconDots size={12} className="tw-stroke-orange" stroke={3} role="img" />
    ),
    backgroundColor: 'tw-bg-orange-100',
    hasLoading: true,
  },
  success: {
    icon: (
      <IconCheck
        size={13}
        stroke={3}
        className="tw-stroke-emerald-500"
        role="img"
      />
    ),
    backgroundColor: 'tw-bg-emerald-300',
    hasLoading: false,
  },
}

export const Toast = ({
  type,
  message,
  duration,
  show,
  onClose,
  noTimeout = false,
}) => {
  useEffect(() => {
    if (show && !noTimeout) {
      const timer = setTimeout(onClose, duration)
      return () => clearTimeout(timer)
    }
  }, [show, duration, onClose, noTimeout])

  return (
    <Transition show={show}>
      <div className="tw-pointer-events-auto tw-right-4 tw-w-full tw-max-w-72 tw-overflow-hidden tw-rounded-lg tw-bg-zinc-800 tw-shadow-lg tw-ring-1 tw-ring-black tw-ring-opacity-5 tw-transition">
        <div className="tw-flex tw-h-14 tw-items-center tw-justify-between tw-gap-2 tw-p-4">
          {type === 'progress' ? (
            <div
              className={cn(
                'tw-flex tw-h-5 tw-w-5 tw-items-center tw-justify-center tw-rounded-xl',
                typeToAssets[type].backgroundColor,
              )}
            >
              {typeToAssets[type].icon}
            </div>
          ) : (
            <IconCircleCheck
              className="tw-h-6 tw-w-6 tw-fill-emerald-500"
              role="img"
            />
          )}
          <div className="tw-flex tw-w-0 tw-flex-1 tw-justify-between">
            <Text className="tw-m-0 tw-flex-1 tw-text-sm tw-font-bold tw-text-white">
              {message}
            </Text>
          </div>
          <div className=" tw-ml-4 tw-flex tw-flex-shrink-0 tw-items-center">
            <button
              type="button"
              onClick={onClose}
              className="tw-font-inherit tw-m-0 tw-flex tw-appearance-none tw-items-center tw-border-none tw-bg-transparent tw-p-0 tw-text-inherit tw-shadow-none tw-outline-none tw-ring-0"
            >
              <span className="tw-sr-only">Close</span>
              <IconX className="tw-size-5 tw-stroke-white tw-opacity-50" />
            </button>
          </div>
        </div>
        {typeToAssets[type].hasLoading && (
          <div
            className="tw-bg-darkGray tw-relative tw-h-1 tw-w-full"
            aria-label="progress bar"
            role="progressbar"
          >
            <div className="tw-absolute tw-h-full tw-animate-empty tw-bg-orange" />
          </div>
        )}
      </div>
    </Transition>
  )
}
